import React, { useContext, useState, useEffect, useMemo } from 'react';
import { fetchData } from '../service/data.service';

const SupportContext = React.createContext();

export const useSupportContext = () => useContext(SupportContext);

export function SupportProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [sharedApps, setSharedApps] = useState({});

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/a51389ca-8776-4f5a-80e0-a4165e8b73a4').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/72a8bb58-fbb0-433e-92fd-70fe21ad26b3')
      .then(setSharedApps);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      sharedApps,
    }),
    [banner, sharedApps]
  );

  return <SupportContext.Provider value={value}>{children}</SupportContext.Provider>;
}
